import { AxiosError, AxiosResponse } from 'axios';
import { useMutation, UseMutationResult, useQueryClient } from 'react-query';
import { ErrorMessage } from 'types';
import { client } from 'utils/api-client';

export default function useArchivePackage(): UseMutationResult<
  AxiosResponse<null>,
  AxiosError<ErrorMessage>,
  string
> {
  const queryClient = useQueryClient();

  const archivePackage = (packageId: string): Promise<AxiosResponse<null>> => {
    return client.put(`packages/${packageId}/archive/`);
  };

  return useMutation(archivePackage, {
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ['billingPlans'],
      });
      queryClient.invalidateQueries({
        queryKey: ['packages'],
      });
    },
  });
}
